import React from "react";
import { Alert, Button } from "components/bootstrap";
import IndexRangeSummary from "components/indices/IndexRangeSummary";
import { IndicesActions } from "stores/indices/IndicesStore";
class ClosedIndexDetails extends React.Component {
  constructor() {
    super(...arguments);
    this._onReopen = () => {
      IndicesActions.reopen(this.props.indexName);
    };
    this._onDeleteIndex = () => {
      if (window.confirm(`Really delete index ${this.props.indexName}?`)) {
        IndicesActions.delete(this.props.indexName);
      }
    };
  }
  render() {
    const { indexRange } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: "index-info" }, /* @__PURE__ */ React.createElement(IndexRangeSummary, { indexRange }), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "This index is closed. Index information is not available at the moment, please reopen the index and try again."), /* @__PURE__ */ React.createElement("hr", { style: { marginBottom: "5", marginTop: "10" } }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", bsSize: "xs", onClick: this._onReopen }, "Reopen index"), " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: this._onDeleteIndex }, "Delete index"));
  }
}
ClosedIndexDetails.defaultProps = {
  indexRange: void 0
};
export default ClosedIndexDetails;
